module.exports = __webpack_public_path__ + "static/media/S&F_EN_LOGO_BLANC.56d0c9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S&F_EN_LOGO_BLANC.png
// module id = 1015
// module chunks = 0